import { RootState } from "core/store/configureStore"

export const getLang = (store: RootState) => store.i18n.currLang
